import { Price, PriceItem } from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./PriceList.module.scss";
import clsx from "clsx";

type Props = {
  topPricesDisclaimer?: string;
  prices: Price[];
  chipBackgroundColor: "neutral05" | "white";
};

const PriceList: React.FC<Props> = ({
  topPricesDisclaimer,
  prices,
  chipBackgroundColor
}) => {
  return (
    <div className={styles.pricesColumn}>
      {topPricesDisclaimer && (
        <div className={styles.topDisplaimer}>{topPricesDisclaimer}</div>
      )}
      <div className={styles.prices}>
        {prices.map((p, index) => {
          return (
            <React.Fragment key={p.fareLabel}>
              {index == 0 ? null : (
                <hr
                  className={clsx({
                    [styles.separatorGray]: chipBackgroundColor == "neutral05"
                  })}
                />
              )}
              <div className={styles.priceItemWrapper}>
                <PriceItem
                  className={styles.priceItem}
                  priceClassName={styles.priceItemInner}
                  layout="column"
                  showFareLabel={true}
                  chipBackgroundColor={chipBackgroundColor}
                  price={p}
                  variant="normal"
                  priceType={index == 0 ? "primary" : "secondary"}
                />
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
export default PriceList;
